import { apiClient, clientConfigService } from "rp-components"
import {
    WALLET_PASSES_MAX_PAGES,
    WALLET_PASSES_PAGE_SIZE,
    WalletConfig,
    WalletPass,
    WalletPlatformsResponse,
    WalletProvisionPayload,
    WalletProvisionResponse
} from "@/models/Wallet"

export interface WalletService {
    getPasses(propertyId: number): Promise<WalletPass[]>
    getConfig(): Promise<WalletConfig | null>
    getPlatforms(propertyId: number, passId: string): Promise<string[]>
    provision(propertyId: number, passId: string, payload: WalletProvisionPayload): Promise<WalletProvisionResponse>
}

class WalletServiceImpl implements WalletService {
    static instance?: WalletService = undefined

    private constructor() {}

    static getInstance(): WalletService {
        if (WalletServiceImpl.instance == undefined) {
            WalletServiceImpl.instance = new WalletServiceImpl()
        }
        return WalletServiceImpl.instance
    }

    async getPasses(propertyId: number): Promise<WalletPass[]> {
        let page = await apiClient.getPage<WalletPass>(`/properties/${propertyId}/hid/v3/passes`, { limit: WALLET_PASSES_PAGE_SIZE })
        const passes = [...page.items]
        for (let pageCount = 1; page.next; pageCount++) {
            if (pageCount >= WALLET_PASSES_MAX_PAGES) {
                throw new Error("The wallet passes do not fit in the pages that can be loaded")
            }
            page = await apiClient.getNextPage<WalletPass>(page.next)
            passes.push(...page.items)
        }
        return passes
    }

    async getConfig(): Promise<WalletConfig | null> {
        const { googleClientId, applePartnerId, appleWalletDomain } = clientConfigService.hid
        if (!googleClientId || !applePartnerId || !appleWalletDomain) {
            return null
        }
        return { googleClientId, applePartnerId, appleWalletDomain }
    }

    async getPlatforms(propertyId: number, passId: string): Promise<string[]> {
        const response = await apiClient.get<WalletPlatformsResponse>(`/properties/${propertyId}/hid/v3/passes/${passId}/supported-platforms`)
        return response.supportedServiceList
    }

    async provision(propertyId: number, passId: string, payload: WalletProvisionPayload): Promise<WalletProvisionResponse> {
        return await apiClient.post<WalletProvisionResponse, WalletProvisionPayload>(`/properties/${propertyId}/hid/v3/passes/${passId}/provision`, payload)
    }
}

export default WalletServiceImpl.getInstance()
